import EnterprisesIndex from './EnterprisesIndex';

export default EnterprisesIndex;
